module.exports = __webpack_public_path__ + "img/8.344796a9.png";